import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Timeline from "./Timeline.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import { API_BASE_URL } from "views/api"

// Sections for this page

const useStyles = makeStyles(styles);

export default function ProductSection(props) {
  const classes = useStyles();

  const [timeline, setTimeline] = React.useState(undefined);
  React.useEffect(() => {
    if (timeline === undefined) {
      fetch(API_BASE_URL + 'introduction/timeline/')
        .then(results => results.json())
        .then(data => {
          setTimeline(data.results);
        });
    }
  });
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} style={{ marginBottom: '20px' }}>
          <div className={classes.section} style={{ color: "#134c7a", margin: 0}}>
            <small>गतिविधि र उपलब्धि</small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>जिल्ला समन्वय समिति भक्तपुरका प्रमुख गतिविधि र उपलब्धिहरु</h3></span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>
          <div style={{ maxHeight: '80vh', border:'5px solid #ccc', backgroundColor: '#ddd', overflowY: 'auto', overflowX: 'hidden', marginTop: '-50px', marginBottom: '30px', paddingTop: '30px' }}><Timeline timeline={timeline}/></div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
